import styled from 'styled-components';
import { em } from 'styles';

import { shouldForwardProp } from 'utils';

export const StyledIcon = styled.span.withConfig({ shouldForwardProp })`
  display: flex;
  align-items: center;
  width: ${({ width }) => em(width) || ''};
  height: ${({ height }) => em(height) || ''};
  justify-content: center;
  max-width: 100%;

  svg {
    color: inherit;
    width: inherit;
    height: inherit;

    path[fill] {
      fill: currentColor;
    }
  }
`;
